export function isPageLoadedAction(action) {
    return /page\/.+ \[done\]/.test(action.type);
}
